const menu = {
    "/admin" : "0",
    "/admin/users" : "1",
    "/admin/master-surat" : "2",
    "/admin/master-surat/manage" : '2',
    "/admin/pengaturan": '3',
    "/admin/surat" : '4',
    "/admin/surat/detail" : '4',
    "/admin/edaran" : '5',
    "/admin/laporan" : '6',
    "/admin/nomor-surat": '8'
}

export default menu